// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"21d816391061db84","931":"7e164976e5041e79"}[chunkId] + ".css";
};